/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Value/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Amount from './Amount/index'
import Percentage from './Percentage/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Value({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content/Sidebar/Content/EditRules/Value"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Amount'
let rulesetCustomPaymentPlanRulesetMinDownpaymentTypeValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'custom_payment_plan_ruleset.min_downpayment_type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: rulesetCustomPaymentPlanRulesetMinDownpaymentTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Amount'}>
<Amount
  viewPath={`${viewPath}/Amount`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Percentage'}>
<Percentage
  viewPath={`${viewPath}/Percentage`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}